import React from 'react';
import StripeElement from 'web/components/StripeElement';
import AccountForm from './accountForm';

const AccountDetail = ({ props, setFieldValue, pageLanguageContents }) => {

  return (
    <StripeElement>
      <AccountForm props={props} setFieldValue={setFieldValue} pageLanguageContents={pageLanguageContents} />
    </StripeElement>
  );
};

export default AccountDetail;
